var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRakuteninline = function SvgRakuteninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.496 22L.5 19.526h21L3.496 22zm3.41-4.33v-5.486h2.412l4.176 5.486h4.276l-5.053-6.619a6.098 6.098 0 002.281-3.036 6 6 0 00.025-3.776 6.094 6.094 0 00-2.241-3.065A6.25 6.25 0 009.137 0H3.496v17.67h3.41zm0-14.315h2.23a2.822 2.822 0 012.026.77c.268.256.481.562.627.9a2.704 2.704 0 01-.627 3.037 2.822 2.822 0 01-2.025.77h-2.23V3.355z",
    fill: "#fff"
  })));
};

export default SvgRakuteninline;